import { render, staticRenderFns } from "./OmniCode.vue?vue&type=template&id=0abcb792&"
import script from "./OmniCode.vue?vue&type=script&lang=js&"
export * from "./OmniCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports